import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ViewTitleService {
    private titleSource = new BehaviorSubject<string>('');
    private descTitleSource = new BehaviorSubject<string>('');
    private backButtonVisibleSource = new BehaviorSubject<boolean>(false);
    private backButtonClickSource = new Subject<void>();

    currentTitle = this.titleSource.asObservable();
    descCurrentTitle = this.descTitleSource.asObservable();
    backButtonVisible = this.backButtonVisibleSource.asObservable();
    backButtonClick = this.backButtonClickSource.asObservable();

    changeTitle(title: string) {
        this.titleSource.next(title);
    }

    changeDescTitle(desc: string) {
        this.descTitleSource.next(desc);
    }

    changeBackButtonVisible(visible: boolean) {
        this.backButtonVisibleSource.next(visible);
    }
}
